import { motion } from 'framer-motion';

const skills = [
    "React", "Three.js", "TypeScript", "Node.js", "Docker", "Python",
    "AWS", "GSAP", "Next.js", "Tailwind", "GraphQL", "PostgreSQL"
];

export function Skills() {
    return (
        <section id="skills" className="py-32 px-6 md:px-12 bg-black/20">
            <div className="max-w-7xl mx-auto text-center">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >
                    <span className="text-emerald-500 font-mono text-sm tracking-widest mb-4 block">
            // 02. ARSENAL
                    </span>
                    <h2 className="text-4xl md:text-5xl font-bold mb-16 text-white">
                        Technical Proficiency
                    </h2>
                </motion.div>

                <div className="flex flex-wrap justify-center gap-4 md:gap-8 max-w-4xl mx-auto">
                    {skills.map((skill, index) => (
                        <motion.div
                            key={skill}
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ delay: index * 0.05, type: "spring" }}
                            whileHover={{ scale: 1.1, color: "#10b981", borderColor: "#10b981" }}
                            className="px-6 py-3 rounded-full border border-white/10 bg-white/5 text-gray-300 font-mono text-sm cursor-default transition-colors duration-300"
                        >
                            {skill}
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
